module.exports = __webpack_public_path__ + "static/img/result-mobile.2cf5e0a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/result-mobile.png
// module id = +MGD
// module chunks = 1